import MuiButton from '@mui/material/Button';
import { styled } from '@mui/system';

import { ContentWrapper } from '../containers/ContentWrapper';

import type { FunctionComponent, MouseEventHandler } from 'react';

const StyledButton = styled(MuiButton)(({ theme }) => ({
    color: theme.palette['text'].primary,
    height: '52px',
    width: '100%',
}));

type OutlinedFullWidthButtonProps = { readonly label: string; readonly onClick: MouseEventHandler };

export const OutlinedFullWidthButton: FunctionComponent<OutlinedFullWidthButtonProps> = (props) => {
    const { label, onClick } = props;

    return (
        <ContentWrapper>
            <StyledButton color="secondary" variant="text" onClick={onClick}>
                {label}
            </StyledButton>
        </ContentWrapper>
    );
};
